import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

const RELOAD_KEY = "futurx_chunk_reload";

export function isChunkLoadError(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const e = err as { name?: string; message?: string };
  const msg = e.message || "";
  return (
    e.name === "ChunkLoadError" ||
    /Loading chunk \d+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
}

export function readReloadFlag(): boolean {
  try { return !!sessionStorage.getItem(RELOAD_KEY); } catch { return false; }
}

export function setReloadFlag() {
  try { sessionStorage.setItem(RELOAD_KEY, "1"); } catch {}
}

export function clearReloadFlag() {
  try { sessionStorage.removeItem(RELOAD_KEY); } catch {}
}

function FallbackUI() {
  return (
    <div style={{ padding: 24, textAlign: "center", fontFamily: "Poppins, sans-serif" }}>
      <h2>Something went wrong</h2>
      <button
        onClick={() => { clearReloadFlag(); window.location.reload(); }}
        style={{
          padding: "8px 20px",
          background: "#0056D2",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        Reload
      </button>
    </div>
  );
}

// Used as the router's errorElement — catches errors thrown inside routes,
// including ChunkLoadError from lazy() after a deploy invalidates chunk hashes.
export function RouteChunkError() {
  const error = useRouteError();
  const isChunk = isChunkLoadError(error);
  const alreadyReloaded = readReloadFlag();

  useEffect(() => {
    if (isChunk && !alreadyReloaded) {
      setReloadFlag();
      window.location.reload();
    }
  }, [isChunk, alreadyReloaded]);

  if (isChunk && !alreadyReloaded) return null;
  return <FallbackUI />;
}
